// extracted by mini-css-extract-plugin
module.exports = {"main":"Button_main__1J5zf"};